var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    id: "magicoon-Regular",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#41416e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "comments") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comments-Regular"
  }, /*#__PURE__*/React.createElement("path", {
    id: "comments-Regular-2",
    "data-name": "comments-Regular",
    className: "cls-1",
    d: "M18,7.25h-.25V6A3.754,3.754,0,0,0,14,2.25H6A3.754,3.754,0,0,0,2.25,6V16a.75.75,0,0,0,.466.694A.741.741,0,0,0,3,16.75a.749.749,0,0,0,.536-.225L5.275,14.75H6.25V16A3.754,3.754,0,0,0,10,19.75h8.725l1.739,1.775A.749.749,0,0,0,21,21.75a.741.741,0,0,0,.284-.056A.75.75,0,0,0,21.75,21V11A3.754,3.754,0,0,0,18,7.25Zm-13.04,6a.75.75,0,0,0-.536.225l-.674.688V6A2.252,2.252,0,0,1,6,3.75h8A2.252,2.252,0,0,1,16.25,6v5A2.252,2.252,0,0,1,14,13.25Zm15.29,5.913-.674-.688a.75.75,0,0,0-.536-.225H10A2.252,2.252,0,0,1,7.75,16V14.75H14A3.754,3.754,0,0,0,17.75,11V8.75H18A2.252,2.252,0,0,1,20.25,11Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.f021c4b8.svg";
export { ForwardRef as ReactComponent };